<template>
    <ReportContainer>
      <template #filter>
        <b-form-group
          label="Assignee">
          <v-select
            :options="options.personnels.items"
            label="name"
            placeholder="ALL"
            clearable
            :disabled="options.personnels.isBusy"
            v-model="filters.collection.personnelId"
            :reduce="personnel => personnel.id"
            :loading="options.personnels.isBusy">
            <template #spinner="{ loading }">
              <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
              </div>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group
          label="From">
          <b-form-datepicker
            v-model="filters.collection.dateFrom"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-form-group
          label="To">
          <b-form-datepicker  v-model="filters.collection.dateTo"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-button variant="outline-primary" @click="onPreviewCollection">Preview</b-button>
      </template>
      <template #content>
        <ReportViewer :reportSource="file.src" :isLoading="file.isLoading"/>
      </template>
    </ReportContainer>
</template>

<script>
import { PersonnelApi, ReportApi } from '../../mixins/api'
import ReportContainer from '../components/ReportContainer'
import ReportViewer from '../components/ReportViewer'
import PersonnelEntryVue from '../settings/personnel/PersonnelEntry.vue'
export default {
  components: {
    ReportContainer,
    ReportViewer
  },
  mixins: [ ReportApi, PersonnelApi ],
  data() {
    return {
      reportSource: '',
      isLoading: false,
      filters:{
        collection: {
          dateFrom: new  Date(),
          dateTo: new  Date(),
          personnelId: null
        }
      },
      file: {
        src: '',
        isLoading: false
      },
      options: {
        personnels: {
          isBusy: false,
          items: []
        }
      }
    }
  },
  created() {
    this.loadPersonnels()
  },
  methods: {
    onPreviewCollection() {
      this.file.src = ''
      this.file.isLoading = true
      const { dateFrom, dateTo, personnelId } = this.filters.collection
      const params = { dateFrom, dateTo, personnelId }
      this.previewCollectionSummary(params).then(response  => {
        const file = new Blob([response.data], { type: "application/pdf" } )
          const reader = new FileReader();
          reader.onload = e => this.file.src = e.target.result
          reader.readAsDataURL(file);
          this.file.isLoading = false
      })
    },
    loadPersonnels() {
      const params = { paginate: false }
      const { personnels } = this.options
      personnels.isBusy = true
      this.getPersonnelList(params)
      .then(({ data }) => {
        personnels.items = data
        personnels.isBusy = false
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .collection-detailed__container {
    height: 100%;
    width: 100%;
  }
</style>